export default {
    AttemptLimitExceeded: 'pages.account.verification.too.many.requests',
    'Incorrect username or password.': 'pages.login.InvalidCredentials',
    InvalidParameterException: 'pages.login.InvalidParameterException',
    NotAuthorizedException: 'pages.login.NotAuthorizedException',
    'Password attempts exceeded': 'pages.login.PasswordAttemptExceeded',
    ResourceNotFoundException: 'pages.login.ResourceNotFoundException',
    UserNotFoundException: 'pages.login.UserNotFoundException',
};
